import { createApi } from 'ReduxHelpers';
import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import {
    type BatchUpdateParams,
    type BatchUpdateResponse,
    type JobBatchProgress,
    type JobBatchResponse,
    type LoadedUser,
    type LoadUsersParams,
    type LoadUsersResponse,
} from '../BatchEditUsers.types';

export const batchEditUsersApi = createApi('batchEditUsersApi', {
    ...getBackRoyalApiBaseConfig('batchEditUsersApi'),
    endpoints: builder => ({
        /*
            This is a search, but it has to be a POST. A GET with a few hundred ids or emails
            exceeds the query string character limit, so we send the identifiers as POST data.
        */
        loadUsers: builder.mutation<LoadedUser[], LoadUsersParams>({
            query: ({ cohortId, identifiers }) => ({
                method: 'post',
                url: 'users/index.json',
                body: {
                    view: 'admin_list',
                    perPage: 9999999999,
                    filters: {
                        programRows: [{ cohortId }],
                        identifiers,
                    },
                },
            }),
            transformResponse: (response: LoadUsersResponse) => response.contents.users,
        }),

        batchUpdateUsers: builder.mutation<string, BatchUpdateParams>({
            query: body => ({ method: 'put', url: 'users/batch_update.json', body }),
            transformResponse: (response: BatchUpdateResponse) => response.contents.jobBatches[0].id,
        }),

        getJobBatch: builder.query<JobBatchProgress, string>({
            query: batchId => ({ url: 'delayed_jobs/get_batch.json', params: { batchId } }),
            transformResponse: (response: JobBatchResponse) => {
                const { pendingCount, errorCount } = response.contents.batches[0];
                return { pendingCount, errorCount };
            },
        }),
    }),
});

export default batchEditUsersApi;
